import React, { useEffect, useState } from "react"
import { FiChevronDown } from "react-icons/fi"
import { Link } from "gatsby"
import { useAnimation, motion, AnimatePresence } from "framer-motion"
import { useInView } from "react-intersection-observer"

const motionSection = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      staggerChildren: 0.3,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
      // when: "beforeChildren",
    },
  },
}
const title = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const underline = {
  hidden: {
    // opacity: 0,
    width: 0,
  },
  visible: {
    opacity: 1,
    // right: 0,
    width: "100%",
    transition: {
      duration: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const motionItems = {
  hidden: {
    opacity: 0,
    y: 20,
    // rotate: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}

const faq = ({ block }) => {
  const { heading, faqItems } = block
  const [isOpen, setIsOpen] = useState(false)

  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  const accordionHandler = (index) => {
    if (isOpen === index) {
      return setIsOpen(null)
    }
    setIsOpen(index)
  }

  return (
    <motion.section
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
      className="section"
    >
      <div className="container max-w-screen-md mx-auto">
        <h2 className="h2 text-center relative w-fit mx-auto mb-8">
          <motion.div variants={title}>{heading}</motion.div>
          <motion.div
            variants={underline}
            className="section-heading__underline bg-orange-400 h-2 w-full absolute -bottom-4 left-0"
          />
        </h2>

        
          <div className="">
            {faqItems.map((item, index) => (
              <motion.div className="py-8 grid gap-2 border-black border-b" variants={motionItems}>
                <motion.div
                  className="flex items-center gap-4 justify-between cursor-pointer"
                  onClick={() => accordionHandler(index)}
                >
                  <h3 className="font-bold">{item.question}</h3>
                  <FiChevronDown className={ isOpen === index ? "transition-transform rotate-180" : "transition-transform" } />
                </motion.div>

                <AnimatePresence>
                  {isOpen === index && (
                    <motion.div
                      initial={{ opacity: 0, y:10, height: 0 }}
                      animate={{
                        opacity: 1,
                        y: 0,
                        height: "100%",
                        transition: {
                          duration: 0.5,
                        },
                      }}
                      exit={{ opacity: 0, y:10, height: 0 }}
                    >
                      <p>{item.answer}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        
      </div>
    </motion.section>
  )
}

export default faq
